import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Breadcrumbs from '../../shared/breadcrumbs/Breadcrumbs';
import '../Technical.css';

class GalleryAPI extends Component {
    render() {
        const ImageCategoriesResponse = process.env.BASE_URL + "images/guides/pcs_image_categories.png";
        return (
            <div className="technical-main">
                <Breadcrumbs />
                <div className="technical-content">
                    <h1 className="main-heading">
                        Gallery API
                </h1>                
                    <h2 className="main-subheading">
                            Methods</h2>
                        <ul>
                            <li className="technical-list-item"><Link to="/technical/galleryapi/echo">pcs.echo</Link></li>
                            <li className="technical-list-item"><Link to="/technical/galleryapi/getcategorylist">pcs.get_category_list</Link></li>
                            <li className="technical-list-item"><Link to="/technical/galleryapi/getcategorycount">pcs.get_category_count</Link></li>
                            <li className="technical-list-item"><Link to="/technical/galleryapi/getcategoryimagelist">pcs.get_category_image_list</Link></li>
                            <li className="technical-list-item"><Link to="/technical/galleryapi/getcategoryimagecount">pcs.get_category_image_count</Link></li>
                            <li className="technical-list-item"><Link to="/technical/galleryapi/searchimages">pcs.search_images</Link></li>
                            <li className="technical-list-item"><Link to="/technical/galleryapi/creategallerycard">pcs.create_gallery_card</Link></li>
                        </ul>
                        <br />
                        <div className="technical-main-content">
                    <h3>
                            Request Format</h3>
                        <p>
                            To call a certain method, just make an HTTP GET request to the following URL:</p>
                        <pre>

                            [base-url]/RestAPI.ashx
                        </pre>
                        <p>
                            The <em>base-url</em> will be assigned by Thales and will be different for each
                            environment (development, testing and production). For example, if the <em>base-url</em>
                            is <em>http://development.example.com</em>, use this URL to call the <Link to="/technical/galleryapi/echo">pcs.echo </Link>
                                method:</p>
                        <pre>
                            http://development.example.com/RestAPI.ashx?method=pcs.echo
                        </pre>
                        <br />
                    <h3>
                            Response Format</h3>
                        <p>
                            The response to any method call is always a simple XML block. If the method was
                            successful, the response will have the following format. The XML payload will depend
                            on the specific method being called.</p>
                        <pre>
                            &lt;?xml version=&quot;1.0&quot; encoding=&quot;utf-8&quot; ?&gt;<br/>
                            &lt;rsp stat=&quot;ok&quot;&gt;<br/>
                            [xml-payload-here]<br/>
                            &lt;/rsp&gt;
                        </pre>
                        <p>
                            If the method fails for any reason, the response will be:</p>
                        <pre>
                            &lt;?xml version=&quot;1.0&quot; encoding=&quot;utf-8&quot; ?&gt;<br/>
                            &lt;rsp stat=&quot;fail&quot;&gt;<br/>
                            &lt;err code=&quot;[error-code]&quot; msg=&quot;[error-message]&quot; /&gt;<br/>
                            &lt;/rsp&gt;
                        </pre>
                        <br />
                    <h3>
                            Designs</h3>
                        <p>
                            The stock image designs referenced by the Gallery API are publicly avaliable via
                            the following web handler:</p>
                        <pre>
                            [base-url]/GetGalleryImage.ashx?api_key=[ handover key] &amp;image_id=[ image  id ]<br/>
                            &emsp; &emsp;&emsp; &emsp;&amp;size=[ size ] &amp;branding=[ &quot;true&quot; or &quot;false&quot; ]<br/>
                            &emsp; &emsp;&emsp; &emsp;&emsp; &emsp;&amp;roundcorners=[ &quot;true&quot; or &quot;false&quot; ] &amp;forceresize=[ &quot;true&quot; or &quot;false&quot; ]<br/>
                        </pre>
                        <p>
                            If the stock image was not the correct aspect ratio for a card then the image returned
                            will be a cropped version of the image, as would be initially displayed on the card
                            when selected in the PCS designer.</p>
                        <p>
                            The order of the parameters is not fixed.</p>
                        <h4>
                            image id</h4>
                        <p>
                            This is the ID returned from the get_category_image_list method.</p>
                        <h4>
                            size</h4>
                        <p>
                            This will determine the size of the image returned. The two current potential sizes
                            available here are:</p>
                        <ul>
                            <li>&quot;thumbnail&quot; - 60 x 60 pixels</li>
                            <li>&quot;review&quot; - 241 x 153 pixels</li>
                            <li>&quot;largereview&quot; - 380 x 241 pixels</li>
                            <li>&quot;original&quot; - the original size of the image uploaded into the admin</li>
                        </ul>
                        <h4>
                            branding (optional parameter)</h4>
                        <p>
                            Determines whether to show the card template overlayed onto the image.<br />
                            Can be &quot;true&quot; or &quot;false&quot;.<br />
                            If parameter not passed then &quot;true&quot; is used as the default.</p>
                        <h4>
                            roundcorners (optional parameter)</h4>
                        <p>
                            Determines whether to show the image with rounded corners.<br />
                            Can be &quot;true&quot; or &quot;false&quot;.<br />
                            If parameter not passed then &quot;true&quot; is used as the default.<br />
                        </p>
                        <h4>
                            forceresize (optional parameter)</h4>
                        <p>
                            Determines whether to show the image at the size stored in the back end or force
                            the resize to a constraint size.<br />
                            Can be &quot;true&quot; or &quot;false&quot;.<br />
                            If parameter not passed then &quot;true&quot; is used as the default.<br />
                        </p>
                        <h4>
                            Examples</h4>
                        <ul>
                            <li>Retrieve the Review size version of the stock image with ID 12345. The image should
                                have the card template applied.
                                <pre>
                                    [base-url]/GetGalleryImage.ashx?image_id=12345&size=review
                                </pre>
                            </li>
                            <li>Retrieve the Large Review size version of the stock image with ID 12345. The image
                                should have no branding applied.
                                <pre>
                                    [base-url]/GetGalleryImage.ashx?image_id=12345& branding=false&size=largereview
                                </pre>
                            </li>
                        </ul>
                        <h3>
                            Error handling</h3>
                        <p>
                            If there is an incorrect request then the response will be a ‘not found’ (type 404)
                            error as no appropriate image will be found.<br />
                            An incorrect request will mean that mandatory parameters have been omitted or the
                            parameter values do not exist.</p>
                        <br />
                        <h3>
                            Image Categories</h3>
                            <p>This API contains all type of image Categories which is enabled from PCS settings.</p>
                                <pre>
                                    [base-url]/designers/handoverKey/ImageCategories?langid=en-US
                                </pre>
                                <pre>
                                <img className="stepbystep-image-alignment stepbystep-image-size" src={ImageCategoriesResponse} alt="Image Categories Response" />
                                </pre>
                        
                    </div>
                </div>
            </div>
        )
    }
}

export default GalleryAPI;